export const tokenAddresses = {
  EUL: "0x80ccFBec4b8c82265abdc226Ad3Df84C0726E7A3",
  eUSD: "0x0000000000000000000000000000000000000000",
  rEUL: "0x021694af083d67950Ac994E63e0a70C30D913836",
  seUSD: "0x0000000000000000000000000000000000000000",
} as const
